// src/api/ai.js
import api from '../api/api';   // همان axios wrapper با baseURL صحیح

const BASE = '/ai';     // آدرس نسبی – آدرس کامل توسط baseURL نمونهٔ api تأمین می‌شود

export async function fetchSessions() {
  const { data } = await api.get(`${BASE}/sessions/`);
  return data;
}

// ✅ تابع جدید: دریافت نشست‌ها با fetch (بدون interceptor)
export async function fetchSessionsWithToken(token) {
  const response = await fetch('https://api.farzaneh.app/api/v1/ai/sessions/', {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (response.status === 401) {
    throw new Error('401');
  }
  if (!response.ok) {
    throw new Error(`Server error: ${response.status}`);
  }
  return response.json();
}

export async function fetchMessages(sessionId) {
  const { data } = await api.get(`${BASE}/messages/`, { params: { session: sessionId } });
  return data;
}

export async function sendFeedback({ response_id, rating, comment, user_query, response_text }) {
  const { data } = await api.post(`${BASE}/feedback/`, {
    response_id,
    rating,
    comment,
    user_query,
    response_text,
  });
  return data;
}

// ✅ تابع جدید: ارسال فیدبک با fetch (بدون interceptor)
export async function sendFeedbackSafe({ token, response_id, rating, comment, user_query, response_text }) {
  const response = await fetch('https://api.farzaneh.app/api/v1/ai/feedback/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({
      response_id,
      rating,
      comment,
      user_query,
      response_text,
    }),
  });
  if (response.status === 401) {
    throw new Error('401');
  }
  if (!response.ok) {
    throw new Error(`Server error: ${response.status}`);
  }
  return response.json();
}

export async function persistMessage({ session_id, role, content }) {
  const { data } = await api.post(`${BASE}/messages/`, { session_id, role, content });
  return data;
}